<template>
<div class="l-modal-full">
  <div class="l-modal-full__content">
    <Loading v-show="loading"></Loading>
    <Generated v-show="generated" :createThumbnailBy="createThumbnailBy"></Generated>
  </div>
</div>
</template>

<script>
import Loading from '@/components/modules/Loading.vue'
import Generated from '@/components/modules/Generated.vue'

export default {
  components: {
    Loading,
    Generated
  },
  props: {
    loading: Boolean,
    generated: Boolean,
    createThumbnailBy: String
  }
}
</script>

<style lang="scss" scoped>
.l-modal-full {
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  overflow-y: scroll;

  &__content {
    width: 1000/1280*100vw;
    min-height: 530/1280*100vw;
    padding: 20px;
    background: #fff;
    border-radius: 2rem;
    box-sizing: border-box;
    @include media-queries-sp {
      width: calc(100% - 40px);
    }
  }
}
</style>
